import { Alert, Box, Stack, Text } from 'braid-design-system';
import { useState, useEffect, type ReactElement, type ReactNode } from 'react';

import { log } from 'src/utils/logging';

export type AlertTone =
  | 'caution'
  | 'critical'
  | 'info'
  | 'positive'
  | 'promote';

interface BannerProps {
  alertTone: AlertTone;
  alertContent: ReactNode;
  onBannerViewed: () => void;
  onBannerClosed: () => void;
  storageTag: string;
}

export const AnnouncementBanner = (props: BannerProps): ReactElement | null => {
  const [isShow, setShow] = useState(false);

  useEffect(() => {
    try {
      const userHasDismissedAnnouncement = window.localStorage.getItem(
        props.storageTag,
      );

      if (!userHasDismissedAnnouncement) {
        setShow(true);
      }
      props.onBannerViewed();
    } catch (err) {
      log.error('AnnoucementBanner | localStorage | getItem', err);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onClickCloseAlert = () => {
    setShow(false);
    try {
      localStorage.setItem(props.storageTag, JSON.stringify(Date.now()));
      props.onBannerClosed();
    } catch (err) {
      log.error('AnnoucementBanner | localStorage | setItem', err);
    }
  };

  return isShow ? (
    <Stack space="medium" align="center">
      <Box width="full" maxWidth="large" paddingTop="medium">
        <Alert
          tone={props.alertTone}
          onClose={onClickCloseAlert}
          closeLabel="Close alert"
        >
          <Text>{props.alertContent}</Text>
        </Alert>
      </Box>
    </Stack>
  ) : null;
};
